import axiosBaseApi from '../axiosBaseApi';
import './ownerTypes';

/**
 * Retrieves owner assets asynchronously.
 * @function getOwnerAssets
 * @returns {Promise<GetOwnerNftAssetsResponse>} The response containing owner assets.
 */
export const getOwnerAssets = async (payload) => {
	try {
		return await axiosBaseApi.get('/owners/assets');
	} catch (error) {
		console.error('Error fetching bot data:', error);
		throw error;
	}
};

export const getOwnerAssetsInventory = async (payload) => {
	try {
		return await axiosBaseApi.get('/owners/assets_inventory?order=collection');
	} catch (error) {
		console.error('Error fetching assets inventory data:', error);
		throw error;
	}
};

export const getOwnerBots = async () => {
	try {
		return await axiosBaseApi.get('/owners/assets_bots');
	} catch (error) {
		console.error('Error fetching bot data:', error);
		throw error;
	}
};

export const getAiAgents = async () => {
	try {
		return await axiosBaseApi.get('/agents');
	} catch (error) {
		console.error('Error fetching ai agents:', error);
		throw error;
	}
};

export const getOwnerRobocaps = async () => {
	try {
		return await axiosBaseApi.get('/owners/robocaps');
	} catch (error) {
		console.error('Error fetching robocaps:', error);
		throw error;
	}
};

export const registerRobocap = async (name) => {
	try {
		return await axiosBaseApi.post('/owners/robocaps', { robocap: { name } });
	} catch (error) {
		console.error('Error registering robocap:', error);
		throw error;
	}
};

export const registerRobocapById = async (robocapId) => {
	try {
		return await axiosBaseApi.post('/owners/robocaps', { robocap: { robocap_id: robocapId } });
	} catch (error) {
		console.error('Error registering robocap by ID:', error);
		throw error;
	}
};

export const unlinkRobocap = async (robocapId) => {
	try {
		return await axiosBaseApi.delete(`/owners/robocaps/${robocapId}`);
	} catch (error) {
		console.error('Error unlinking robocap:', error);
		throw error;
	}
};

export const checkRobocapUpload = async (robocapId, dbFileHashes) => {
	try {
		return await axiosBaseApi.post(`/owners/robocaps/${robocapId}/check_upload`, {
			db_file_hashes: dbFileHashes
		});
	} catch (error) {
		console.error('Error checking upload:', error);
		throw error;
	}
};

export const registerRobocapUploads = async (robocapId, directoryName, files, taskId) => {
	try {
		const params = { directory_name: directoryName, files };
		if (taskId) {
			params.task_id = taskId;
		}
		return await axiosBaseApi.post(`/owners/robocaps/${robocapId}/register_uploads`, params);
	} catch (error) {
		console.error('Error registering uploads:', error);
		throw error;
	}
};

export const presignRobocapUpload = async (robocapId, uploadId, contentType) => {
	try {
		return await axiosBaseApi.post(`/owners/robocaps/${robocapId}/presign_upload`, {
			upload_id: uploadId,
			content_type: contentType
		});
	} catch (error) {
		console.error('Error presigning upload:', error);
		throw error;
	}
};

export const confirmRobocapUpload = async (robocapId, uploadId) => {
	try {
		return await axiosBaseApi.post(`/owners/robocaps/${robocapId}/confirm_upload`, {
			upload_id: uploadId
		});
	} catch (error) {
		console.error('Error confirming upload:', error);
		throw error;
	}
};

export const failRobocapUpload = async (robocapId, uploadId) => {
	try {
		return await axiosBaseApi.post(`/owners/robocaps/${robocapId}/fail_upload`, {
			upload_id: uploadId
		});
	} catch (error) {
		console.error('Error failing upload:', error);
	}
};

export const retryRobocapUpload = async (robocapId, uploadId, contentType) => {
	try {
		return await axiosBaseApi.post(`/owners/robocaps/${robocapId}/retry_upload`, {
			upload_id: uploadId,
			content_type: contentType
		});
	} catch (error) {
		console.error('Error retrying upload:', error);
		throw error;
	}
};

export const getRobocapSessions = async (robocapId) => {
	try {
		return await axiosBaseApi.get(`/owners/robocaps/${robocapId}/sessions`);
	} catch (error) {
		console.error('Error fetching robocap sessions:', error);
		throw error;
	}
};

export const getRobocapSessionUploads = async (robocapId, taskId) => {
	try {
		return await axiosBaseApi.get(`/owners/robocaps/${robocapId}/sessions/${taskId}/uploads`);
	} catch (error) {
		console.error('Error fetching session uploads:', error);
		throw error;
	}
};
